import { render, staticRenderFns } from "./EventNewMulti.vue?vue&type=template&id=35403746"
import script from "./EventNewMulti.vue?vue&type=script&lang=js"
export * from "./EventNewMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports